import strFunc from "@/lib/lyg/string";

function DetListArea(props: any) {
  let myProps = {
    order_det_info_arr: [],
    set_order_det_info_arr: (inData: any) => { },
    stu_info_arr: [],
    xColumnArr: {},
    ...props
  };
  let { order_det_info_arr, set_order_det_info_arr, stu_info_arr, xColumnArr } = myProps;

  const on_change_order_det = (inData: any) => {
    let opt_obj = {
      row_num: 0,
      name: "",
      value: "",
      change_order_det: {},
      ...inData
    };
    if (strFunc.is_empty(opt_obj.name)) {
      return false;
    }
    let change_order_det = order_det_info_arr[opt_obj.row_num];
    change_order_det[opt_obj.name] = opt_obj.value;
    change_order_det = {
      ...change_order_det,
      ...opt_obj.change_order_det
    };
    let new_order_det_info_arr = [...order_det_info_arr];
    new_order_det_info_arr[opt_obj.row_num] = change_order_det;
    set_order_det_info_arr(new_order_det_info_arr);
  };

  const get_order_det_tr_tags = () => {
    let tr_tags: any = order_det_info_arr.map((order_det: any, order_det_idx: number) => {
      console.log(order_det);
      let product_name = "";
      if (order_det.product_info) {
        product_name = order_det.product_info.a_title;
      }
      return (
        <tr key={order_det_idx}>
          {xColumnArr.x_column_list_arr.map((col: any, col_idx: number) => {
            if (col.is_show == "1") {
              let td_render_str: any = "";
              if (col.key == "product_name") {
                td_render_str = product_name;
              } else if (col.key == "stu_name") {
                td_render_str = order_det.a_buy_user_name;
              } else if (col.key == "online_sort") {
                if (order_det.product_info && order_det.product_info.mtextbook_info) {
                  if (order_det.product_info.mtextbook_info.a_is_online == "1") {
                    td_render_str = "온라인";
                  }
                }
              } else if (col.key == "use_sort") {
                if (order_det.product_info && order_det.product_info.mtextbook_info) {
                  if(strFunc.is_empty(order_det.a_product_use_sort)){
                    order_det.a_product_use_sort="main";
                  }
                  let main_btn_class=order_det.a_product_use_sort == "main" ? "blue" : "dark";
                  main_btn_class="btn btn-" + main_btn_class;
                  let sub_btn_class=order_det.a_product_use_sort == "sub" ? "blue" : "dark";
                  sub_btn_class="btn btn-" + sub_btn_class;
                  
                  td_render_str = (
                    <div className="my_flex_center">
                      <button className={main_btn_class}
                        onClick={() => {
                          on_change_order_det({
                            row_num: order_det_idx,
                            name: "a_product_use_sort",
                            value: "main"
                          });
                        }}
                      >메인</button>
                      <button className={sub_btn_class}
                        onClick={() => {
                          on_change_order_det({
                            row_num: order_det_idx,
                            name: "a_product_use_sort",
                            value: "sub"
                          });
                        }}
                      >서브</button>
                    </div>
                  );
                }
              }
              return (
                <td key={"td_" + col_idx} className="text-center">
                  {td_render_str}
                </td>
              );
            }
          })}
        </tr>
      );
    });
    return tr_tags;
  };

  return (
    <div>
      <div className="list-table-div">
        <table>
          <colgroup>
            {xColumnArr.x_column_list_arr.map((col: any, col_idx: number) => {
              if (col.is_show == "1") {
                return <col key={"col_" + col_idx} style={{ width: col.width + "%" }}></col>
              }
            })}
          </colgroup>
          <thead>
            <tr>
              {xColumnArr.x_column_list_arr.map((col: any, col_idx: number) => {
                if (col.is_show == "1") {
                  return <th key={"th_" + col_idx}>{col.name}</th>
                }
              })}
            </tr>
          </thead>
          <tbody>
            {get_order_det_tr_tags()}
          </tbody>
        </table>
      </div>
    </div>
  );
};
export default DetListArea;